import { Injectable } from '@angular/core';
import { HttpHelper } from 'app/shared/common/utils/http/HttpHelper';
import { Observable } from 'rxjs';
import { IRequestSwitchApp } from './interface/miniapps.interface';
import { SWITCH_APP_URL } from './constants/miniapp.constant';

@Injectable({
    providedIn: 'root'
})
export class MiniappsService {
    /**
     * Constructor
     */
    constructor(private _httpHelper: HttpHelper) {
    }

    getMiniApps(): Promise<any> {
        const url: string = 'assets/data/miniapps.json';
        return this._httpHelper.methodGetService(url);
    }

    public getTokenOfSwitchApp(payLoad: IRequestSwitchApp): Observable<any> {
        return this._httpHelper.methodPostObservableService(SWITCH_APP_URL, payLoad);
    } 

}